import React from 'react'
import { Button, Form, Input, Modal, message } from 'antd'
import TableAPI from '../../../components/TableAPI'
import { columns } from './columns'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'
import { View } from '../../../../styles/reactnative'

const IPSetting = () => {
	const [modalVisible, setModalVisible] = React.useState(false)
	const [ip, setIp] = React.useState('')
	const { data: token } = useToken()

	return (
		<>
			<TableAPI
				title={'IP차단설정'}
				columns={columns}
				usermodal={false}
				height={'default'}
				apikey={`/admin/ip?t=`}
				pagination={false}
				action={mutate => {
					return (
						<Button
							type="primary"
							onClick={() => {
								setModalVisible(true)
							}}>
							차단등록
						</Button>
					)
				}}
				actionmodal={mutate => {
					return (
						<Modal
							title="IP차단등록"
							visible={modalVisible}
							okText="등록"
							cancelText="취소"
							onOk={() => {
								API.send('POST', '/admin/ip', token + '', {
									ip: ip,
								}).then(res => {
									message.success('등록되었습니다.')
									mutate(1)
								})
								setModalVisible(false)
							}}
							onCancel={() => {
								setModalVisible(false)
							}}>
							<Input
								value={ip}
								onChange={e => setIp(e.target.value)}
								placeholder="IP주소"
							/>
						</Modal>
					)
				}}
			/>
		</>
	)
}

export default React.memo(IPSetting)
